import React from "react";
import ArticleList from "./ArticleList";

const ArticlesSection: React.FC = () => (
  <section id="articles" className="w-full flex flex-col items-center py-16 sm:py-24 px-4 sm:px-6 scroll-mt-20 bg-[#f5f0e8]">
    <ArticleList />
  </section>
);

export default ArticlesSection;
